


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const fulllaser: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "laser-hair-removal",
        "meta": {
            "title": "Laser Hair Removal Dubai | Elite Body Home",
            "description": "Safe and effective laser hair removal treatment for permanent hair reduction on all body areas. Suitable for both men and women with all skin types.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/laser-hair-removal/",
            "og": {
                "title": "Laser Hair Removal Dubai | Elite Body Home",
                "description": "Permanent hair reduction with advanced laser technology for all skin types",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Laser Hair Removal"],
        "hero": {
            "title": "Laser Hair Removal Dubai",
            "subtitle": "Long-Lasting Smooth, Hair-Free Skin",
            "description": "Laser hair removal is an advanced cosmetic procedure that offers long-lasting hair reduction by delivering concentrated light energy to the hair follicles. Arguably, one of the best hair removal treatment you can get is full body laser and as this procedure gets a significant edge over conventional hair-removing methods such as shaving, waxing and tweezing, the effects gained from it would get you a lifetime guarantee. Because it is non-invasive, and can be used on almost all parts of the body, it is a popular choice for both men and women who desire smooth hair-free skin."
        },
        "howItWorks": {
            "title": "How Laser Hair Treatment Works",
            "description": "It is ideal for long term hair reduction with a targeted laser wavelength that works effectively with hair follicles. The Candela Gentle Max Pro laser is one of the most effective treatments of all, making it the best laser for hair removal on all skin types. The cooling properties of the system deliver optimum comfort, making it very popular with men and women alike looking for smooth, hair-free skin with a superior alternative to other hair removal solutions such as shaving and waxing."
        },
        "procedureSteps": {
            "heading": "Steps in Laser Hair Removal Treatment",
            "para": "Laser hair removal is a procedure that uses concentrated light beams that dive into the unwanted hair and destroys its roots. The hair pigment absorbs the laser energy, which destroys the follicle's state of new hair production and then the hair growth is greatly reduced.",
            "steps": [
                {
                    "title": "Laser Targets Hair Follicles",
                    "desc": "The laser releases light energy that is absorbed by the melanin in the hair, heating it and destroying the follicle.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Precision and Control",
                    "desc": "The treatment targets hair through deep penetration but leaves surrounding skin tissue unharmed.",
                    "icon": "fa-solid fa-crosshairs"
                },
                {
                    "title": "Multiple Sessions Required",
                    "desc": "Because hair grows in cycles, multiple treatments are necessary to affect the follicles at various points in their growth stages.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Cooling Technology",
                    "desc": "Modern lasers are equipped with cooling systems to lessen pain during the procedure.",
                    "icon": "fa-solid fa-snowflake"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages of Laser Hair Removal",
            "subheading": "Why choose laser over traditional methods",
            "para": "One of the reasons most people choose this treatment is because of the benefits of laser hair removal. Here are some of the major benefits:",
            "items": [
                {
                    "title": "Long-Lasting Results",
                    "desc": "Compared to shaving or waxing prices, laser hair removal provides hair reduction, as a majority of patients report permanent hair removal after a few sessions.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Precision",
                    "desc": "Lasers are only effective on dark and coarse hair, which leaves the surrounding skin unharmed.",
                    "icon": "fa-solid fa-ruler-combined"
                },
                {
                    "title": "Quick and Efficient",
                    "desc": "Each pulse of the laser lasts a fraction of a second and can treat many hairs at once, so the treatment for large areas, such as the back or the legs, can be completed quickly.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Smoother Skin",
                    "desc": "Over multiple treatments, the skin will be smoother, with no ingrown hairs or stubble.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "eligibility": {
            "heading": "Best Candidate for Laser Hair Removal Service",
            "subheading": "",
            "para": "Laser is an amazing multifaceted treatment, but may not be right for every person. The effectiveness of the treatment along with other variables like hair color, skin type or existing health conditions can play a role in how successful the treatment will be.",
            "items": [
                {
                    "title": "Suitable Skin and Hair Types",
                    "desc": "The best results typically occur in those with a light skin and dark hair contrast as this creates a disparity between the skin and hair pigment. But new laser technology has allowed for a broader spectrum of skin tones to be treated.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "Areas for Treatment",
                    "desc": "Common areas are the legs, underarms, bikini line, face and back. Laser hair removal is suitable for both men and women.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "Healthy Skin Condition",
                    "desc": "Good candidates are those with healthy, intact skin at the site of treatment. Certain skin conditions, recent sunburns or active infections are contraindications for treatment, and should be resolved before treatment.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Pregnancy",
                    "desc": "It should be avoided in pregnant women.",
                    "icon": "fa-solid fa-baby"
                }
            ]
        },
        "preparationTips": {
            "heading": "Before Preparing for Laser Hair Removal Session",
            "subheading": "",
            "para": "Laser treatment for hair removal is a great way to get rid of unwanted hair permanently. Specific pre-treatment instructions help ensure that the treatment works as efficiently as possible, and that you're as comfortable as possible during and after treatment.",
            "items": [
                {
                    "title": "Sun Protection",
                    "desc": "Stay out of the sun for two weeks beforehand.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Avoid Waxing/Plucking",
                    "desc": "No waxing or plucking; shaving is OK.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Shave Before Treatment",
                    "desc": "Do shave the area 24 hours prior to treatment.",
                    "icon": "fa-solid fa-cut"
                },
                {
                    "title": "Avoid Certain Products",
                    "desc": "Lay off retinoids and acids a day or two beforehand.",
                    "icon": "fa-solid fa-flask"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Laser treatment is gradual and gives visible results - you will notice less and less hair each time after each lightning session. But the results are permanent and life-changing.",
            "items": [
                {
                    "title": "Gradual Hair Reduction",
                    "desc": "With each session, the hair becomes thinner and more tempered until it is permanently removed.",
                    "icon": "fa-solid fa-chart-line-down"
                },
                {
                    "title": "Smoother, Silkier Skin",
                    "desc": "Your skin appears significantly smoother and softer, without shaving or waxing.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "No More Ingrown Hairs",
                    "desc": "It also removes the risk of painful ingrown hairs - a common side effect of traditional hair removal tools.",
                    "icon": "fa-solid fa-times-circle"
                },
                {
                    "title": "Minimal Maintenance",
                    "desc": "Once the first series of treatments is completed, only periodic touch-ups may be needed to keep your results.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "",
            "para": "Laser hair removal is an excellent choice for people who want to be hair-free, but taking care of your skin afterward is extremely important to ensure it not only looks great but also gets the most benefits from the treatment.",
            "items": [
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Avoid direct sunlight on the treated area for at least two weeks.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Skip Heat Treatments",
                    "desc": "Avoid hot showers, saunas and steam rooms for at least 48 hours after treatment.",
                    "icon": "fa-solid fa-fire-alt"
                },
                {
                    "title": "Use Soothing Products",
                    "desc": "You can also apply a cool compress for soothing or an aloe vera gel to wipe away any redness or discomfort on the treated area.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Gentle Skincare",
                    "desc": "And for a week, you should steer clear of any harsh exfoliating products or scrubs on the treated area.",
                    "icon": "fa-solid fa-hands-wash"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "If you're considering Laser Hair Removal in Dubai, you may have several questions about the procedure, its effectiveness, and what to expect. Here are some of the most frequently asked questions to help you make an informed decision.",
            "items": [
                {
                    "question": "How many laser hair removal treatments do I need?",
                    "answer": "Most clients require 6-8 sessions for optimal results, varying by hair growth cycles, color, and skin type. Some may need occasional maintenance sessions."
                },
                {
                    "question": "Is laser hair removal safe?",
                    "answer": "Yes, it's FDA-approved and safe for all skin types. Our advanced laser technology ensures gentle treatment."
                },
                {
                    "question": "Is laser treatment effective for facial hair removal?",
                    "answer": "Yes, it effectively reduces facial hair by targeting follicles. Our experts customize treatment for delicate facial areas."
                },
                {
                    "question": "What types of laser hair removal treatments are available?",
                    "answer": "We offer advanced technologies like Candela GentleMax Pro, tailored for different skin tones and hair types."
                },
                {
                    "question": "Does laser hair treatment hurt?",
                    "answer": "Most clients describe it as mild discomfort, like a rubber band snap. Our equipment includes cooling features for comfort."
                },
                {
                    "question": "How many treatments are needed for permanent hair removal?",
                    "answer": "6-8 sessions typically achieve permanent reduction by targeting hair at different growth stages."
                },
                {
                    "question": "What are the side effects of laser hair treatment?",
                    "answer": "Mild, temporary effects like slight redness or swelling may occur, usually resolving within hours to a day."
                },
                {
                    "question": "What is the cost of laser hair removal in Dubai?",
                    "answer": "Cost depends on treatment area and sessions needed. We offer competitive pricing with personalized packages."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/New-Service-Bannesr-Image-8-scaled.jpg",
            "beforeAfter": [
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/laser-h-1.jpg",
                    alt: "underarm laser hair removal",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/laser-h-2.jpg",
                    alt: "best laser hair removal dubai",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/laser-h-3.jpg",
                    alt: "laser hair removal dubai",
                },
            ]
        },
        "product": {
            "id": 50,
            "title": "Laser Hair Removal in Dubai",
            "description": "Permanent hair reduction with advanced laser technology for all skin types.",
            "price": 500
        }
    },
    "ar": {
        "url": "laser-hair-removal",
        "meta": {
            "title": "إزالة الشعر بالليزر في دبي | ايليت بودي هوم",
            "description": "علاج آمن وفعال لإزالة الشعر بالليزر بشكل دائم لجميع مناطق الجسم. مناسب للرجال والنساء بجميع أنواع البشرة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/laser-hair-removal",
            "og": {
                "title": "إزالة الشعر بالليزر في دبي | ايليت بودي هوم",
                "description": "تقليل الشعر بشكل دائم بتقنية الليزر المتقدمة لجميع أنواع البشرة",
                "image": "https://www.elitebodyhome.com/images/laser-hair-removal-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة الشعر بالليزر"],
        "hero": {
            "title": "إزالة الشعر بالليزر في دبي",
            "subtitle": "بشرة ناعمة خالية من الشعر لفترة طويلة",
            "description": "يعد إزالة الشعر بالليزر إجراء تجميلي حديث، صُمم لتقليل الشعر الغير مرغوب فيه بشكل دائم من خلال استخدام أشعة ضوء مُركزة لاستهداف بصيلات الشعر. يوفر إزالة الشعر بالليزر نتائج طويلة الأمد لكامل الجسم حيث يعتبر أكثر الطرق المتاحة تأثيرًا، كما إنه بديلًا شائعًا للطرق التقليدية مثل الحلاقة، والشمع، والنتف. يصلح استخدامه لأجزاء مختلفة في الجسم حيث إنه إجراء غير جراحي، مما يجعله الاختيار المثالي للرجال والنساء لازالة الشعر الزائد والحصول على بشرة ناعمة."
        },
        "howItWorks": {
            "title": "كيف يتم إزالة الشعر بالليزر؟",
            "description": "يعتبر إزالة الشعر بالليزر إجراء غير جراحي يوفر نتائج طويلة الأمد من خلال استهداف بصيلات الشعر بواسطة أشعة ضوء مركزة. يتميز جهاز كانديلا جنتل ماكس برو من بين أكثر العلاجات فعالية بتقنيته المتقدمة مما يمكنه من تحقيق نتائج دقيقة وقوية لجميع أنواع البشرة، كما تضمن خاصية التبريد به أقصى درجات الراحة، مما يجعله خيارًا مثاليًا للرجال والنساء الطامحين لبشرة ناعمة خالية من الشعر وبديل أفضل للطرق التقليدية مثل الحلاقة والشمع."
        },
        "procedureSteps": {
            "heading": "خطوات إزالة الشعر بالليزر",
            "para": "يتضمن إزالة الشعر بالليزر استخدام أشعة ضوئية عالية التركيز التي تخترق الجلد لاستهداف وتدمير بصيلات الشعر ومنع نمو الشعر. يساعد تصبغ الشعر في امتصاص طاقة الليزر مما يعيق قدرة البُصيلة في إنتاج شعر جديد.",
            "steps": [
                {
                    "title": "استهداف بصيلات الشعر",
                    "desc": "تنبعث طاقة ضوئية من الليزر يمتصها الميلانين بالشعر، مما يرفع درجة حرارة بصيلة الشعر ويؤدي إلى تدميرها.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "الدقة والتحكم",
                    "desc": "صُمم العلاج بحيث يستهدف الشعر بدقة للحفاظ على الجلد المحيط.",
                    "icon": "fa-solid fa-crosshairs"
                },
                {
                    "title": "يتطلب عدة جلسات",
                    "desc": "ينمو الشعر في دورات، لذلك يلزم عدة جلسات لاستهداف البصيلات خلال مراحل النمو المختلفة.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "تقنية التبريد",
                    "desc": "تظهر أغلب أجهزة الليزر الحديثة بآلية التبريد لتوفر راحة أكثر خلال الجلسات.",
                    "icon": "fa-solid fa-snowflake"
                }
            ]
        },
        "benefits": {
            "heading": "مميزات إزالة الشعر الليزر",
            "subheading": "لماذا تختار الليزر عن الطرق التقليدية",
            "para": "يوفر إزالة الشعر بالليزر مجموعة واسعة من المميزات، مما يجعله الخيار المفضل لمن يحتاج إلى حل طويل الأمد لتقليل الشعر. فيما يلي بعض المزايا الرئيسية:",
            "items": [
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تقلل إزالة الشعر بالليزر معدل نمو الشعر بشكل واضح على عكس طرق الحلاقة والشمع، حيث ينعم الكثير من العملاء بانخفاض دائم في معدل ظهور الشعر بعد عدة جلسات.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "الدقة",
                    "desc": "يستهدف الليزر بشكل انتقائي الشعر الداكن الخشن بينما يترك الجلد المحيط دون ضرر.",
                    "icon": "fa-solid fa-ruler-combined"
                },
                {
                    "title": "سريع وفعال",
                    "desc": "تستغرق كل نبضة ليزر جزءًا من الثانية فقط ويمكنها علاج أكثر من بصيلة في وقت واحد، مما يسمح بالعلاج السريع لمناطق كبيرة مثل الظهر والساقين.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "بشرة أنعم",
                    "desc": "يصبح الجلد أكثر نعومة وخالي من الشعر النامي تحت الجلد ومن الشعر القصير بعد عدة جلسات.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "eligibility": {
            "heading": "المرشح المثالي لخدمة إزالة الشعر بالليزر",
            "subheading": "",
            "para": "في حين أن الليزر علاج متعدد الاستخدامات، فقد لا يكون مناسبًا للجميع. فتؤثر عوامل مثل لون الشعر ونوع البشرة والحالات الصحية الأساسية على فعاليته.",
            "items": [
                {
                    "title": "أنسب أنواع شعر وبشرة",
                    "desc": "يحصل الأشخاص أصحاب البشرة الفاتحة والشعر الداكن على أفضل نتائج، ويرجع ذلك للتباين بين صبغة البشرة والشعر، ومع ذلك، مكنت التطورات في تكنولوجيا الليزر علاج نطاق أوسع من درجات البشرة.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "مناطق العلاج",
                    "desc": "تتضمن المناطق الشائعة الساقين، وتحت الابطين، والبيكيني، والوجه، والظهر. يمكن لكل من الرجال والنساء الاستفادة من إزالة الشعر بالليزر.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "حالة الجلد الصحية",
                    "desc": "يعتبر الأشخاص الذين يتمتعون ببشرة صحية وسليمة في منطقة العلاج هم المرشحون المثاليون بينما يجب على من يعاني من مشاكل جلدية، أو حروق شمسية حديثة، أو عدوى نشطة تأجيل العلاج حتى يتم حل هذه المشاكل.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "الحمل",
                    "desc": "لا ينصح بإجراء الليزر للحوامل.",
                    "icon": "fa-solid fa-baby"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد لجلسة إزالة الشعر بالليزر",
            "subheading": "",
            "para": "يعد التحضير الجيد قبل الخضوع لعلاج إزالة الشعر بالليزر أمر بالغ الأهمية لضمان تحقيق أفضل النتائج وتقليل خطر الآثار الجانبية، حيث يعزز اتباع تعليمات ما قبل العلاج من فعالية الإجراء ويحسن راحتك أثناء الجلسة وبعدها.",
            "items": [
                {
                    "title": "الحماية من الشمس",
                    "desc": "تجنب التعرض لأشعة الشمس لمدة أسبوعين قبل الجلسة.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "تجنب الشمع/النتف",
                    "desc": "تجنب إزالة الشعر بالشمع أو النتف، يمكن استخدام الحلاقة.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الحلاقة قبل العلاج",
                    "desc": "يفضل حلق المنطقة قبل 24 ساعة من العلاج.",
                    "icon": "fa-solid fa-cut"
                },
                {
                    "title": "تجنب بعض المنتجات",
                    "desc": "تجنب استخدام الريتينويدات والأحماض لبضعة أيام قبل الجلسة.",
                    "icon": "fa-solid fa-flask"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يوفر العلاج بالليزر نتائج مرئية مع مرور الوقت، حيث تقلل كل جلسة من نمو الشعر تدريجيًا. يستغرق الحصول على بشرة ناعمة وخالية من الشعر وقتًا، لكن تدوم النتائج طويلاً وتكون جذرية.",
            "items": [
                {
                    "title": "تقليل الشعر تدريجيًا",
                    "desc": "يَصير الشعر أرق وأقل كثافة بعد كل جلسة، مما يؤدي في النهاية إلى تقليل الشعر بشكل دائم.",
                    "icon": "fa-solid fa-chart-line-down"
                },
                {
                    "title": "بشرة أكثر نعومة وحريرية",
                    "desc": "تصبح بشرتك أكثر نعومة بشكل ملحوظ وأخف لقلة الحاجة لإزالة الشعر بالحلاقة أو الشمع.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "اختفاء الشعر النامي تحت الجلد",
                    "desc": "يقضي إزالة الشعر بالليزر على خطر نمو الشعر تحت الجلد المؤلم، وهي مشكلة شائعة مع طرق إزالة الشعر التقليدية.",
                    "icon": "fa-solid fa-times-circle"
                },
                {
                    "title": "سهولة العناية",
                    "desc": "يمكن الاحتياج إلى بعض اللمسات الخفيفة فقط بعد الانتهاء من سلسلة العلاجات الأولية للحفاظ على نتائجك.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح للعناية بعد إزالة الشعر بالليزر",
            "subheading": "",
            "para": "يعد إزالة الشعر بالليزر وسيلة فعالة للغاية للحصول على بشرة ناعمة وخالية من الشعر، ولكن العناية المناسبة اللاحقة بالجلسة ضرورية لحماية بشرتك وتحسين النتائج.",
            "items": [
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "تجنب تعرض المنطقة المُعالَجة لأشعة الشمس المباشرة لمدة لا تقل عن أسبوعين.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "تجنب الحرارة",
                    "desc": "تجنب الاستحمام بالماء الساخن، والساونا، وغرف البخار لمدة لا تقل عن 48 ساعة بعد العلاج.",
                    "icon": "fa-solid fa-fire-alt"
                },
                {
                    "title": "استخدام منتجات مهدئة",
                    "desc": "ضع كمادات باردة مهدئة أو جل الألوفيرا على المنطقة المُعالًجة لتهدئة أي احمرار أو انزعاج.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "العناية اللطيفة بالبشرة",
                    "desc": "تجنب استخدام أي منتجات تقشير قاسية أو دعك المنطقة المُعالجة لمدة أسبوع.",
                    "icon": "fa-solid fa-hands-wash"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "إذا كنت تفكر في إزالة الشعر بالليزر في دبي، فقد يكون لديك عدة أسئلة حول الإجراء، وفعاليته، وما يمكن توقعه. إليك بعض الأسئلة الأكثر شيوعًا لمساعدتك على اتخاذ قرار مستنير.",
            "items": [
                {
                    "question": "كم عدد جلسات إزالة الشعر بالليزر التي أحتاجها؟",
                    "answer": "معظم العملاء يحتاجون إلى 6-8 جلسات للحصول على نتائج مثالية، تختلف حسب دورة نمو الشعر، لونه، ونوع البشرة. قد يحتاج البعض إلى جلسات صيانة عرضية."
                },
                {
                    "question": "هل إزالة الشعر بالليزر آمنة؟",
                    "answer": "نعم، إنها معتمدة من FDA وآمنة لجميع أنواع البشرة. تضمن تقنية الليزر المتقدمة لدينا علاجًا لطيفًا."
                },
                {
                    "question": "هل علاج الليزر فعال لإزالة شعر الوجه؟",
                    "answer": "نعم، فهو يقلل بشكل فعال من شعر الوجه عن طريق استهداف البصيلات. يقوم خبراؤنا بتخصيص العلاج للمناطق الحساسة في الوجه."
                },
                {
                    "question": "ما أنواع علاجات إزالة الشعر بالليزر المتاحة؟",
                    "answer": "نحن نقدم تقنيات متقدمة مثل كانديلا جنتل ماكس برو، المصممة لأنواع مختلفة من درجات البشرة وأنواع الشعر."
                },
                {
                    "question": "هل علاج إزالة الشعر بالليزر مؤلم؟",
                    "answer": "يصف معظم العملاء الإحساس بعدم الراحة البسيط، مثل طقطقة الشريط المطاطي. يتضمن جهازنا ميزات تبريد للراحة."
                },
                {
                    "question": "كم عدد الجلسات اللازمة للإزالة الدائمة للشعر؟",
                    "answer": "تحقق 6-8 جلسات عادةً تقليلًا دائمًا للشعر عن طريق استهدافه في مراحل نمو مختلفة."
                },
                {
                    "question": "ما هي الآثار الجانبية لعلاج إزالة الشعر بالليزر؟",
                    "answer": "قد تحدث آثار جانبية خفيفة ومؤقتة مثل احمرار طفيف أو تورم، وعادة ما تختفي في غضون ساعات إلى يوم."
                },
                {
                    "question": "ما هي تكلفة إزالة الشعر بالليزر في دبي؟",
                    "answer": "تعتمد التكلفة على منطقة العلاج وعدد الجلسات المطلوبة. نقدم أسعارًا تنافسية مع حزم شخصية."
                }
            ]
        }
    }
}